export default __webpack_public_path__ + "static/media/black-king.ca375cb4.png";